import { render, staticRenderFns } from "./RecetasNewFormComponent.vue?vue&type=template&id=6ef32a36&scoped=true&"
import script from "./RecetasNewFormComponent.vue?vue&type=script&lang=js&"
export * from "./RecetasNewFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecetasNewFormComponent.vue?vue&type=style&index=0&id=6ef32a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef32a36",
  null
  
)

export default component.exports